var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"residence-gallery-app"}},[(_vm.residenceData)?_c('GalleryWrapper',{attrs:{"pictures":_vm.pictures,"prestations":_vm.prestations}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }